import template   from './manage-purchase-topblock.html'
import controller from './manage-purchase-topblock.controller'

let component = {
  restrict: 'E',
  bindings: {
    disableBack: '<'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/common/manage-purchase-topblock/manage-purchase-topblock.component.js